// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createCar,
  deleteCar,
  fetchCities,
  fetchCity,
  updateCar,
} from "../../../../../../redux/slices/adminSlice";
import { ImSpinner2 } from "react-icons/im";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlinePlus } from "react-icons/ai"; // Keep AiFillDelete if still needed for modals
import { FaXmark } from "react-icons/fa6";
import Modal from "react-modal";
import Select from "react-select";

// Images
// import empty from "../../../../../../assets/images/empty.png"; // No longer needed directly here, will be in CarCategories
// import { BiSolidCity } from "react-icons/bi"; // No longer needed directly here, will be in CarCategories

// Import AdminCitiesLayout and CarCategories
import AdminCitiesLayout from "../CitiesLayout"; // Adjust path if necessary
import { CarCategories } from "./CarCategories"; // Adjust path if necessary

function AdminCarRates() {
  const { token, isLoading, cities, currentCity } = useSelector(
    (store) => store.admin
  );
  const dispatch = useDispatch();

  const [isAddCarModalOpen, setIsAddCarModalOpen] = useState(false);

  // Add Car Form Fields
  const [cityForNewCar, setCityForNewCar] = useState(null); // Renamed to avoid conflict
  const [carName, setCarName] = useState(""); // Initialize with empty string
  const [price, setPrice] = useState(""); // Initialize with empty string

  const [selectedCity, setSelectedCity] = useState(null); // State to manage which city is selected in the CitiesLayout

  // Function: Handles the creation of a new car
  async function handleAddCar(e) {
    e.preventDefault();
    if (!cityForNewCar || !carName || !price) {
      toast.error("Please fill in the missing fields");
      return;
    }
    dispatch(
      createCar({
        token,
        city: cityForNewCar?.value,
        name: carName,
        price: price,
      })
    );
    setIsAddCarModalOpen(false);
    setCarName(""); // Clear form fields
    setPrice("");
    setCityForNewCar(null);
  }

  // MODIFY CAR Modal State & Handlers
  const [isCarDetailModalOpen, setIsCarDetailModalOpen] = useState(false);
  const [currentCar, setCurrentCar] = useState(null);
  const [carNameModified, setCarNameModified] = useState("");
  const [priceModified, setPriceModified] = useState("");

  // Populate modification fields when a car is selected
  useEffect(() => {
    if (currentCar) {
      setCarNameModified(currentCar.name ?? "");
      setPriceModified(currentCar.price ?? ""); // Changed 0 to "" for better UX if price is empty
    }
  }, [currentCar]);

  async function handleUpdateCar(e) {
    e.preventDefault();

    if (!priceModified || !carNameModified) {
      toast.error("Please fill in the missing fields");
      return;
    }
    dispatch(
      updateCar({
        token,
        carId: currentCar?._id,
        name: carNameModified,
        price: priceModified,
        city: currentCar?.city, // Ensure city ID is passed for the update
      })
    );
    setIsCarDetailModalOpen(false);
  }

  async function handleDeleteCar(carId, cityId) {
    // Added cityId here
    dispatch(
      deleteCar({
        token,
        carId: carId,
        city: cityId ?? selectedCity?.value, // Use the passed cityId first, then selectedCity
      })
    );
    setIsCarDetailModalOpen(false);
  }

  // Fetch cities for the 'car' type initially
  useEffect(() => {
    dispatch(fetchCities({ token, type: "car" }));
  }, [token]);

  // Format cities data for Select component
  const [citiesDataForSelect, setCitiesDataForSelect] = useState([]);
  useEffect(() => {
    const updatedCityData = cities?.map((city) => ({
      value: city._id,
      label: city.cityName,
    }));
    setCitiesDataForSelect(updatedCityData || []);
  }, [cities]);

  // This useEffect handles fetching the selected city's details (including its cars)
  useEffect(() => {
    if (selectedCity?.value) {
      // Only dispatch if a city is actually selected
      dispatch(
        fetchCity({
          cityId: selectedCity.value,
          token: token,
          type: "car",
        })
      );
    } else if (!selectedCity && citiesDataForSelect.length > 0) {
      // Optionally, set the first city as selected by default if none is chosen
      // setSelectedCity(citiesDataForSelect[0]);
    }
  }, [selectedCity, token, citiesDataForSelect]);

  return (
    <div className="mt-10">
      <ToastContainer />

      {/* Add Car Modal */}
      <Modal
        isOpen={isAddCarModalOpen}
        onRequestClose={() => setIsAddCarModalOpen(false)}
        className="flex h-full min-h-screen justify-center items-center lg:px-24 px-7"
      >
        <div className="bg-white shadow-lg rounded-lg text-shuttlelaneBlack lg:w-2/4 w-full p-7 px-10">
          <div className="flex items-center justify-between">
            <div className="">
              <h4 className="font-semibold">Add Car</h4>
              <small>Create a new car</small>
            </div>
            <FaXmark
              size={20}
              onClick={() => setIsAddCarModalOpen(false)}
              className="cursor-pointer"
            />
          </div>

          <form className="w-full mt-5" onSubmit={handleAddCar}>
            <div className="flex flex-col gap-y-5 lg:items-center gap-x-4">
              <div className="w-full flex flex-col">
                <label htmlFor="city" className="text-sm">
                  City
                </label>
                <div className="flex items-center bg-gray-100 h-[47px] px-2 gap-x-2 w-full rounded-lg">
                  <div className="w-full text-shuttlelaneBlack text-sm relative">
                    <Select
                      value={cityForNewCar}
                      onChange={(value) => setCityForNewCar(value)}
                      options={citiesDataForSelect} // Use formatted data
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused
                            ? "transparent"
                            : "transparent",
                          borderWidth: state.isFocused ? "0" : "0",
                          backgroundColor: "transparent",
                          position: "relative",
                        }),
                        placeholder: (baseStyles) => ({ ...baseStyles }),
                        menuList: (baseStyles) => ({ ...baseStyles }),
                        input: (baseStyles) => ({ ...baseStyles }),
                      }}
                      placeholder="Select City"
                    />
                  </div>
                </div>
              </div>

              <div className="w-full flex flex-col">
                <label htmlFor="carName" className="text-sm">
                  Car Name
                </label>
                <input
                  type="text"
                  placeholder="Toyota Camry 2019"
                  name="carName"
                  value={carName}
                  onChange={(e) => setCarName(e.target.value)}
                  className="w-full text-sm h-11 p-3 border-[0.3px] bg-transparent focus:outline-none border-gray-400 rounded-lg"
                />
              </div>

              <div className="w-full flex flex-col">
                <label htmlFor="price" className="text-sm">
                  Price per day
                </label>
                <div className="w-full flex items-center">
                  <label
                    htmlFor="price"
                    className="text-sm inline-block p-3 bg-gray-200 h-11 rounded-tl-lg rounded-bl-lg"
                  >
                    ₦
                  </label>
                  <input
                    type="number"
                    placeholder="40,000"
                    name="price"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="w-full text-sm h-11 p-3 border-[0.3px] bg-transparent focus:outline-none border-gray-400 rounded-tr-lg rounded-br-lg"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full flex justify-center items-center text-sm text-white hover:text-shuttlelaneBlack h-11 p-3 transition-all hover:border-[1px] hover:bg-transparent bg-shuttlelanePurple focus:outline-none border-gray-400 rounded-lg"
              >
                {isLoading ? (
                  <ImSpinner2 size={21} className="animate-spin" />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </form>
        </div>
      </Modal>

      {/* Car Details Modal (Update/Delete Car) */}
      <Modal
        isOpen={isCarDetailModalOpen}
        onRequestClose={() => setIsCarDetailModalOpen(false)}
        className="flex h-full min-h-screen justify-center items-center lg:px-24 px-7"
      >
        <div className="bg-white shadow-lg rounded-lg text-shuttlelaneBlack lg:w-2/4 w-full p-7 px-10">
          <div className="flex items-center justify-between">
            <div className="">
              <h4 className="font-semibold">{currentCar?.name}</h4>
              <small>More details for {currentCar?.name}</small>
            </div>
            <FaXmark
              size={20}
              onClick={() => setIsCarDetailModalOpen(false)}
              className="cursor-pointer"
            />
          </div>

          <form className="w-full mt-5" onSubmit={handleUpdateCar}>
            <div className="flex flex-col gap-y-5 lg:items-center gap-x-4">
              <div className="w-full flex flex-col">
                <label htmlFor="carNameModified" className="text-sm">
                  Car Name
                </label>
                <input
                  type="text"
                  placeholder="Toyota Camry 2019"
                  name="carNameModified"
                  value={carNameModified}
                  onChange={(e) => setCarNameModified(e.target.value)}
                  className="w-full text-sm h-11 p-3 border-[0.3px] bg-transparent focus:outline-none border-gray-400 rounded-lg"
                />
              </div>

              <div className="w-full flex flex-col">
                <label htmlFor="priceModified" className="text-sm">
                  Price per day
                </label>
                <div className="w-full flex items-center">
                  <label
                    htmlFor="priceModified"
                    className="text-sm inline-block p-3 bg-gray-200 h-11 rounded-tl-lg rounded-bl-lg"
                  >
                    ₦
                  </label>
                  <input
                    type="number"
                    placeholder="40,000"
                    name="priceModified"
                    value={priceModified}
                    onChange={(e) => setPriceModified(e.target.value)}
                    className="w-full text-sm h-11 p-3 border-[0.3px] bg-transparent focus:outline-none border-gray-400 rounded-tr-lg rounded-br-lg"
                  />
                </div>
              </div>

              <div className="w-full flex lg:flex-row flex-col lg:justify-between items-center gap-5">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full flex justify-center items-center text-sm text-white hover:text-shuttlelaneBlack h-11 p-3 transition-all hover:border-[1px] hover:bg-transparent bg-shuttlelanePurple focus:outline-none border-gray-400 rounded-lg"
                >
                  {isLoading ? (
                    <ImSpinner2 size={21} className="animate-spin" />
                  ) : (
                    "Save Changes"
                  )}
                </button>
                <button
                  type="button" // Important: set to type="button" to prevent form submission
                  disabled={isLoading}
                  onClick={() =>
                    handleDeleteCar(currentCar?._id, currentCar?.city)
                  } // Pass both car ID and city ID
                  className="w-full flex justify-center items-center text-sm text-red-500 hover:text-white h-11 p-3 transition-all hover:border-[1px] hover:bg-red-500 border-red-500 rounded-lg"
                >
                  {isLoading ? (
                    <ImSpinner2 size={21} className="animate-spin" />
                  ) : (
                    "Delete Car"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      <div className="flex gap-x-5 flex-wrap gap-y-3 items-end pb-3 border-b-[1.3px] lg:border-b-[.5px] border-b-gray-200">
        <div className="">
          <p className="text-lg font-semibold">
            Cities and Car Rental Locations
          </p>
          <small className="">
            Manage cities and car rental locations on Shuttlelane
          </small>
        </div>

        {/* Add car button */}
        <button
          onClick={() => setIsAddCarModalOpen(true)}
          className="w-auto border-dashed border-[8px] lg:border-[.3px] border-shuttlelaneBlack p-1 rounded-sm flex items-center gap-x-1"
        >
          <AiOutlinePlus size={16} />
          <span className="text-xs">Add Car</span>
        </button>
      </div>

      {/* AdminCitiesLayout is a parent for CarCategories now */}
      <AdminCitiesLayout
        type="car"
        tab2Component={() => (
          // THIS IS CRUCIAL: Pass it as a function that RETURNS the component
          <CarCategories
            selectedCity={selectedCity}
            setSelectedCity={setSelectedCity}
            citiesDataForSelect={citiesDataForSelect}
            isLoading={isLoading}
            currentCity={currentCity}
            setIsCarDetailModalOpen={setIsCarDetailModalOpen}
            setCurrentCar={setCurrentCar}
            handleDeleteCar={handleDeleteCar}
          />
        )}
      />
    </div>
  );
}

export default AdminCarRates;
